module.exports = __webpack_public_path__ + "filled-circle/filled-circle-28b244f44c3dc8487cbe23b48bbb06d2.svg";